import axios from "axios";
import { supportTicketConf } from "@/constant/config";

export default {
    getTicketCategory() {
        return axios({
            method: "GET",
            url: supportTicketConf.getTicketCategory,
            withCredentials: true,
        });
    },
    getTicketType(categoryId) {
        return axios({
            method: "GET",
            url: `${supportTicketConf.getTicketType}/${categoryId}`,
            withCredentials: true,
        });
    },
    getQuantilyTicket(id) {
        return axios({
            method: "GET",
            url: supportTicketConf.getQuantilyTicket,
            withCredentials: true,
        });
    },
    submitTicket(data) {
        return axios({
            method: "POST",
            url: `${supportTicketConf.submitTicket}`,
            data: data,
            withCredentials: true,
        });
    },
}